import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HrHeroComponent } from '../../Components/HR/hr-hero/hr-hero';
import { HrFeaturesComponent } from '../../Components/HR/hr-features/hr-features';
import { HrOverviewComponent } from '../../Components/HR/hr-overview/hr-overview';
import { HrMobileComponent } from '../../Components/HR/hr-mobile/hr-mobile';
import { HrCtaComponent } from '../../Components/HR/hr-cta/hr-cta';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-hr-page',
  standalone: true,
  imports: [CommonModule, HrHeroComponent, HrOverviewComponent, HrFeaturesComponent, HrMobileComponent, HrCtaComponent],
  templateUrl: './hr-page.html',
  styleUrls: ['./hr-page.css'],
})
export class HrPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'HR Management Software',
      description:
        'Manage recruitment, employee records, payroll, and attendance in one place with orderYaa HR — part of the orderYaa ERP suite.',
      path: '/hr',
    });
  }
}
